import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import type { CollectorSettings } from './collector-settings-form.types'
import {
  CompressionField,
  EncryptionField,
  OsAndOutput,
  ResourceLimits,
  TimeoutsBlock,
} from './collector-settings-form/collector-settings-form.parts'

export type { CollectorSettings } from './collector-settings-form.types'
export { DEFAULT_COLLECTOR_SETTINGS } from './collector-settings-form.types'

interface CollectorSettingsFormProps {
  settings: CollectorSettings
  onChange: (settings: CollectorSettings) => void
}

export function CollectorSettingsForm({
  settings,
  onChange,
}: CollectorSettingsFormProps): ReactElement {
  const { t } = useTranslation('cases')

  function update<K extends keyof CollectorSettings>(key: K, value: CollectorSettings[K]): void {
    onChange({ ...settings, [key]: value })
  }

  return (
    <div className="space-y-4">
      <OsAndOutput settings={settings} update={update} t={t} />
      <EncryptionField settings={settings} update={update} t={t} />
      <CompressionField settings={settings} update={update} t={t} />
      <ResourceLimits settings={settings} update={update} t={t} />
      <TimeoutsBlock settings={settings} update={update} t={t} />
    </div>
  )
}
